module.exports = __webpack_public_path__ + "img/service1.d997cde.svg";